import { Component, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidDialogLine } from '../../components/rid-dialog-line/rid-dialog-line';
import { RidHorizontalPages } from '../../components/rid-horizontal-pages/rid-horizontal-pages';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { ExpressionService } from '../../services/expression-service.service';

@Component({
  selector: 'rid-dialog',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidMechanicTitle,
    RidBottomButton,
    RidHorizontalPages,
    RidDialogLine,
  ],
  templateUrl: './rid-dialog.html',
  host: {
    class: 'block',
  },
})
export class RidDialog implements OnInit, OnDestroy {
  private readonly $expressionService = inject(ExpressionService);

  pages = input.required<{ speaker: 'LEFT' | 'RIGHT'; content: string }[][]>();

  progress = signal(0);
  index = signal(0);

  finished = output<void>();

  ngOnInit(): void {
    this.$expressionService.setAvailability('CLIENT', true);
    this.$expressionService.setAvailability('TUTOR', true);
  }

  ngOnDestroy(): void {
    this.$expressionService.setAvailability('CLIENT', false);
    this.$expressionService.setAvailability('TUTOR', false);
  }
}
